import React from "react";
import styles from "./CircleLoader.module.scss";

const CircleLoader = () => {
  return (
    <div className={styles.circleLoaderMainContainer}>
      <div className={`${styles.circle} ${styles.circle1}`}></div>
      <div className={`${styles.circle} ${styles.circle2}`}></div>
      <div className={`${styles.circle} ${styles.circle3}`}></div>
    </div>
  );
};

export default CircleLoader;
